export const timezones = [
  'Etc/GMT+12',
  'Etc/GMT+11',
  'Pacific/Midway',
  'Pacific/Niue',
  'Pacific/Pago Pago',
  'Pacific/Samoa',
  'US/Samoa',
  'Etc/GMT+10',
  'Pacific/Honolulu',
  'Pacific/Johnston',
  'Pacific/Rarotonga',
  'Pacific/Tahiti',
  'US/Hawaii',
  'Pacific/Marquesas',
  'America/Adak',
  'America/Atka',
  'Etc/GMT+9',
  'Pacific/Gambier',
  'US/Aleutian',
  'America/Anchorage',
  'America/Juneau',
  'America/Metlakatla',
  'America/Nome',
  'America/Sitka',
  'America/Yakutat',
  'Etc/GMT+8',
  'Pacific/Pitcairn',
  'US/Alaska',
  'America/Chihuahua',
  'America/Creston',
  'America/Dawson',
  'America/Dawson Creek',
  'America/Ensenada',
  'America/Fort Nelson',
  'America/Hermosillo',
  'America/Los Angeles',
  'America/Mazatlan',
  'America/Phoenix',
  'America/Santa Isabel',
  'America/Tijuana',
  'America/Vancouver',
  'America/Whitehorse',
  'Canada/Pacific',
  'Canada/Yukon',
  'Etc/GMT+7',
  'Mexico/BajaNorte',
  'Mexico/BajaSur',
  'US/Arizona',
  'US/Pacific',
  'America/Bahia Banderas',
  'America/Belize',
  'America/Boise',
  'America/Cambridge Bay',
  'America/Costa Rica',
  'America/Denver',
  'America/Edmonton',
  'America/El Salvador',
  'America/Guatemala',
  'America/Inuvik',
  'America/Managua',
  'America/Merida',
  'America/Mexico City',
  'America/Monterrey',
  'America/Ojinaga',
  'America/Regina',
  'America/Shiprock',
  'America/Swift Current',
  'America/Tegucigalpa',
  'America/Yellowknife',
  'Canada/Mountain',
  'Canada/Saskatchewan',
  'Etc/GMT+6',
  'Mexico/General',
  'Pacific/Galapagos',
  'US/Mountain',
  'America/Atikokan',
  'America/Bogota',
  'America/Cancun',
  'America/Cayman',
  'America/Chicago',
  'America/Coral Harbour',
  'America/Eirunepe',
  'America/Guayaquil',
  'America/Indiana/Knox',
  'America/Indiana/Tell City',
  'America/Jamaica',
  'America/Knox IN',
  'America/Lima',
  'America/Matamoros',
  'America/Menominee',
  'America/North Dakota/Beulah',
  'America/North Dakota/Center',
  'America/North Dakota/New Salem',
  'America/Panama',
  'America/Porto Acre',
  'America/Rainy River',
  'America/Rankin Inlet',
  'America/Resolute',
  'America/Rio Branco',
  'America/Winnipeg',
  'Brazil/Acre',
  'Canada/Central',
  'Chile/EasterIsland',
  'Etc/GMT+5',
  'Pacific/Easter',
  'US/Central',
  'US/Indiana-Starke',
  'America/Anguilla',
  'America/Antigua',
  'America/Aruba',
  'America/Asuncion',
  'America/Barbados',
  'America/Blanc-Sablon',
  'America/Boa Vista',
  'America/Campo Grande',
  'America/Caracas',
  'America/Cuiaba',
  'America/Curacao',
  'America/Detroit',
  'America/Dominica',
  'America/Fort Wayne',
  'America/Grand Turk',
  'America/Grenada',
  'America/Guadeloupe',
  'America/Guyana',
  'America/Havana',
  'America/Indiana/Indianapolis',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indianapolis',
  'America/Iqaluit',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Kralendijk',
  'America/La Paz',
  'America/Louisville',
  'America/Lower Princes',
  'America/Manaus',
  'America/Marigot',
  'America/Martinique',
  'America/Montreal',
  'America/Montserrat',
  'America/Nassau',
  'America/New York',
  'America/Nipigon',
  'America/Pangnirtung',
  'America/Port-au-Prince',
  'America/Port of Spain',
  'America/Porto Velho',
  'America/Puerto Rico',
  'America/Santo Domingo',
  'America/St Barthelemy',
  'America/St Kitts',
  'America/St Lucia',
  'America/St Thomas',
  'America/St Vincent',
  'America/Thunder Bay',
  'America/Toronto',
  'America/Tortola',
  'America/Virgin',
  'Brazil/West',
  'Canada/Eastern',
  'Etc/GMT+4',
  'US/East-Indiana',
  'US/Eastern',
  'US/Michigan',
  'America/Araguaina',
  'America/Argentina/Buenos Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/ComodRivadavia',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San Juan',
  'America/Argentina/San Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Bahia',
  'America/Belem',
  'America/Buenos Aires',
  'America/Catamarca',
  'America/Cayenne',
  'America/Cordoba',
  'America/Fortaleza',
  'America/Glace Bay',
  'America/Goose Bay',
  'America/Halifax',
  'America/Jujuy',
  'America/Maceio',
  'America/Mendoza',
  'America/Moncton',
  'America/Montevideo',
  'America/Paramaribo',
  'America/Punta Arenas',
  'America/Recife',
  'America/Rosario',
  'America/Santarem',
  'America/Santiago',
  'America/Sao Paulo',
  'America/Thule',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Atlantic/Bermuda',
  'Atlantic/Stanley',
  'Brazil/East',
  'Canada/Atlantic',
  'Chile/Continental',
  'Etc/GMT+3',
  'America/St Johns',
  'Canada/Newfoundland',
  'America/Godthab',
  'America/Miquelon',
  'America/Noronha',
  'America/Nuuk',
  'Atlantic/South Georgia',
  'Brazil/DeNoronha',
  'Etc/GMT+2',
  'Atlantic/Cape Verde',
  'Etc/GMT+1',
  'Africa/Abidjan',
  'Africa/Accra',
  'Africa/Bamako',
  'Africa/Banjul',
  'Africa/Bissau',
  'Africa/Casablanca',
  'Africa/Conakry',
  'Africa/Dakar',
  'Africa/El Aaiun',
  'Africa/Freetown',
  'Africa/Lome',
  'Africa/Monrovia',
  'Africa/Nouakchott',
  'Africa/Ouagadougou',
  'Africa/Sao Tome',
  'Africa/Timbuktu',
  'America/Danmarkshavn',
  'America/Scoresbysund',
  'Atlantic/Azores',
  'Atlantic/Reykjavik',
  'Atlantic/St Helena',
  'Etc/GMT',
  'Etc/GMT+0',
  'Etc/GMT-0',
  'Etc/GMT0',
  'Etc/Greenwich',
  'Etc/UCT',
  'Etc/UTC',
  'Etc/Universal',
  'Etc/Zulu',
  'Africa/Algiers',
  'Africa/Bangui',
  'Africa/Brazzaville',
  'Africa/Douala',
  'Africa/Kinshasa',
  'Africa/Lagos',
  'Africa/Libreville',
  'Africa/Luanda',
  'Africa/Malabo',
  'Africa/Ndjamena',
  'Africa/Niamey',
  'Africa/Porto-Novo',
  'Africa/Tunis',
  'Atlantic/Canary',
  'Atlantic/Faeroe',
  'Atlantic/Faroe',
  'Atlantic/Madeira',
  'Etc/GMT-1',
  'Europe/Belfast',
  'Europe/Dublin',
  'Europe/Guernsey',
  'Europe/Isle of Man',
  'Europe/Jersey',
  'Europe/Lisbon',
  'Europe/London',
  'Africa/Blantyre',
  'Africa/Bujumbura',
  'Africa/Cairo',
  'Africa/Ceuta',
  'Africa/Gaborone',
  'Africa/Harare',
  'Africa/Johannesburg',
  'Africa/Juba',
  'Africa/Khartoum',
  'Africa/Kigali',
  'Africa/Lubumbashi',
  'Africa/Lusaka',
  'Africa/Maputo',
  'Africa/Maseru',
  'Africa/Mbabane',
  'Africa/Tripoli',
  'Africa/Windhoek',
  'Antarctica/Troll',
  'Arctic/Longyearbyen',
  'Atlantic/Jan Mayen',
  'Etc/GMT-2',
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Budapest',
  'Europe/Busingen',
  'Europe/Copenhagen',
  'Europe/Gibraltar',
  'Europe/Kaliningrad',
  'Europe/Ljubljana',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Monaco',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Prague',
  'Europe/Rome',
  'Europe/San Marino',
  'Europe/Sarajevo',
  'Europe/Skopje',
  'Europe/Stockholm',
  'Europe/Tirane',
  'Europe/Vaduz',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zurich',
  'Africa/Addis Ababa',
  'Africa/Asmara',
  'Africa/Asmera',
  'Africa/Dar es Salaam',
  'Africa/Djibouti',
  'Africa/Kampala',
  'Africa/Mogadishu',
  'Africa/Nairobi',
  'Antarctica/Syowa',
  'Asia/Aden',
  'Asia/Amman',
  'Asia/Baghdad',
  'Asia/Bahrain',
  'Asia/Beirut',
  'Asia/Damascus',
  'Asia/Famagusta',
  'Asia/Gaza',
  'Asia/Hebron',
  'Asia/Istanbul',
  'Asia/Jerusalem',
  'Asia/Kuwait',
  'Asia/Nicosia',
  'Asia/Qatar',
  'Asia/Riyadh',
  'Asia/Tel Aviv',
  'Etc/GMT-3',
  'Europe/Athens',
  'Europe/Bucharest',
  'Europe/Chisinau',
  'Europe/Helsinki',
  'Europe/Istanbul',
  'Europe/Kiev',
  'Europe/Kirov',
  'Europe/Mariehamn',
  'Europe/Minsk',
  'Europe/Moscow',
  'Europe/Nicosia',
  'Europe/Riga',
  'Europe/Simferopol',
  'Europe/Sofia',
  'Europe/Tallinn',
  'Europe/Tiraspol',
  'Europe/Uzhgorod',
  'Europe/Vilnius',
  'Europe/Volgograd',
  'Europe/Zaporozhye',
  'Indian/Antananarivo',
  'Indian/Comoro',
  'Indian/Mayotte',
  'Asia/Baku',
  'Asia/Dubai',
  'Asia/Muscat',
  'Asia/Tbilisi',
  'Asia/Yerevan',
  'Etc/GMT-4',
  'Europe/Astrakhan',
  'Europe/Samara',
  'Europe/Saratov',
  'Europe/Ulyanovsk',
  'Indian/Mahe',
  'Indian/Mauritius',
  'Indian/Reunion',
  'Asia/Kabul',
  'Asia/Tehran',
  'Antarctica/Mawson',
  'Asia/Aqtau',
  'Asia/Aqtobe',
  'Asia/Ashgabat',
  'Asia/Ashkhabad',
  'Asia/Atyrau',
  'Asia/Dushanbe',
  'Asia/Karachi',
  'Asia/Oral',
  'Asia/Qyzylorda',
  'Asia/Samarkand',
  'Asia/Tashkent',
  'Asia/Yekaterinburg',
  'Etc/GMT-5',
  'Indian/Kerguelen',
  'Indian/Maldives',
  'Asia/Calcutta',
  'Asia/Colombo',
  'Asia/Kolkata',
  'Asia/Kathmandu',
  'Asia/Katmandu',
  'Antarctica/Vostok',
  'Asia/Almaty',
  'Asia/Bishkek',
  'Asia/Dacca',
  'Asia/Dhaka',
  'Asia/Kashgar',
  'Asia/Omsk',
  'Asia/Qostanay',
  'Asia/Thimbu',
  'Asia/Thimphu',
  'Asia/Urumqi',
  'Etc/GMT-6',
  'Indian/Chagos',
  'Asia/Rangoon',
  'Asia/Yangon',
  'Indian/Cocos',
  'Antarctica/Davis',
  'Asia/Bangkok',
  'Asia/Barnaul',
  'Asia/Ho Chi Minh',
  'Asia/Hovd',
  'Asia/Jakarta',
  'Asia/Krasnoyarsk',
  'Asia/Novokuznetsk',
  'Asia/Novosibirsk',
  'Asia/Phnom Penh',
  'Asia/Pontianak',
  'Asia/Saigon',
  'Asia/Tomsk',
  'Asia/Vientiane',
  'Etc/GMT-7',
  'Indian/Christmas',
  'Asia/Brunei',
  'Asia/Choibalsan',
  'Asia/Chongqing',
  'Asia/Chungking',
  'Asia/Harbin',
  'Asia/Hong Kong',
  'Asia/Irkutsk',
  'Asia/Kuala Lumpur',
  'Asia/Kuching',
  'Asia/Macao',
  'Asia/Macau',
  'Asia/Makassar',
  'Asia/Manila',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Taipei',
  'Asia/Ujung Pandang',
  'Asia/Ulaanbaatar',
  'Asia/Ulan Bator',
  'Australia/Perth',
  'Australia/West',
  'Etc/GMT-8',
  'Australia/Eucla',
  'Asia/Chita',
  'Asia/Dili',
  'Asia/Jayapura',
  'Asia/Khandyga',
  'Asia/Pyongyang',
  'Asia/Seoul',
  'Asia/Tokyo',
  'Asia/Yakutsk',
  'Etc/GMT-9',
  'Pacific/Palau',
  'Australia/Darwin',
  'Australia/North',
  'Antarctica/DumontDUrville',
  'Asia/Ust-Nera',
  'Asia/Vladivostok',
  'Australia/Brisbane',
  'Australia/Lindeman',
  'Australia/Queensland',
  'Etc/GMT-10',
  'Pacific/Chuuk',
  'Pacific/Guam',
  'Pacific/Port Moresby',
  'Pacific/Saipan',
  'Pacific/Truk',
  'Pacific/Yap',
  'Australia/Adelaide',
  'Australia/Broken Hill',
  'Australia/South',
  'Australia/Yancowinna',
  'Antarctica/Casey',
  'Antarctica/Macquarie',
  'Asia/Magadan',
  'Asia/Sakhalin',
  'Asia/Srednekolymsk',
  'Australia/ACT',
  'Australia/Canberra',
  'Australia/Currie',
  'Australia/Hobart',
  'Australia/LHI',
  'Australia/Lord Howe',
  'Australia/Melbourne',
  'Australia/NSW',
  'Australia/Sydney',
  'Australia/Tasmania',
  'Australia/Victoria',
  'Etc/GMT-11',
  'Pacific/Bougainville',
  'Pacific/Efate',
  'Pacific/Guadalcanal',
  'Pacific/Kosrae',
  'Pacific/Noumea',
  'Pacific/Pohnpei',
  'Pacific/Ponape',
  'Asia/Anadyr',
  'Asia/Kamchatka',
  'Etc/GMT-12',
  'Pacific/Fiji',
  'Pacific/Funafuti',
  'Pacific/Kwajalein',
  'Pacific/Majuro',
  'Pacific/Nauru',
  'Pacific/Norfolk',
  'Pacific/Tarawa',
  'Pacific/Wake',
  'Pacific/Wallis',
  'Antarctica/McMurdo',
  'Antarctica/South Pole',
  'Etc/GMT-13',
  'Pacific/Apia',
  'Pacific/Auckland',
  'Pacific/Enderbury',
  'Pacific/Fakaofo',
  'Pacific/Kanton',
  'Pacific/Tongatapu',
  'Pacific/Chatham',
  'Etc/GMT-14',
  'Pacific/Kiritimati',
]
